export default __webpack_public_path__ + "static/media/eng-work-1404.4fe67391.xlsx";